let entitydbRt = {
    "pinned": [
      "CompanyName"
    ],
    "width": {
      "CompanyName": 240
    },
    "immutable": {
      "CompanyName": false
    },
    "mapping": {
      "CompanyName": {
        "header": "Company Name",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CompanyName"
      },
      "Status": {
        "header": "Company Status",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Status",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Active",
          "Dissolved",
          "In Liquidation",
          "Liquidated",
          "Struck Off"
        ]
      },
      "FundFamily": {
        "header": "Fund Family",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FundFamily",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Fund I",
          "Fund II",
          "Fund III",
          "Fund IV",
          "Fund V",
          "Fund VI",
          "Fund VII"
        ]
      },
      "Purpose": {
        "header": "Entity Purpose",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Purpose",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "AIV",
          "AIV Yukon",
          "Blocker",
          "Carry Vehicle",
          "Co-Investment",
          "Comingled Fund",
          "Feeder Fund",
          "General Partner",
          "Management Company",
          "Parallel Fund",
          "Partner Vehicle",
          "Separate Account",
          "Side Car",
          "Sleeve Fund",
          "SPV"
        ]
      },
      "Country": {
        "header": "Country",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Country",
        "cellEditor": "agTextCellEditor"
      },
      "LargeTraderID": {
        "header": "Large Trader Identification Number (Number used for 13H filings)",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "LargeTraderID",
        "cellEditor": "agTextCellEditor"
      },
      "FFARegNum": {
        "header": "Foreign Financial Authority Registration (foreign registration #)",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FFARegNum",
        "cellEditor": "agTextCellEditor"
      },
      "QualBusIn": {
        "header": "Qualified to do business in",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "QualBusIn",
        "cellEditor": "agTextCellEditor"
      },
      "AIFMDReg1": {
        "header": "AIFMD Registration No 1",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AIFMDReg1",
        "cellEditor": "agTextCellEditor"
      },
      "AIFMDReg2": {
        "header": "AIFMD Registration No 2",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AIFMDReg2",
        "cellEditor": "agTextCellEditor"
      },
      "AIFMDReg3": {
        "header": "AIFMD Registration No 3",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AIFMDReg3",
        "cellEditor": "agTextCellEditor"
      },
      "AIFMDReg4": {
        "header": "AIFMD Registration No 4",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AIFMDReg4",
        "cellEditor": "agTextCellEditor"
      },
      "FinraCRDNum": {
        "header": "FINRA CRD Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FinraCRDNum",
        "cellEditor": "agTextCellEditor"
      },
      "AnnRptDueDate": {
        "header": "Annual Report Due Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AnnRptDueDate",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "March 31",
          "June 30",
          "September 30",
          "December 31",
          "Not Applicable"
        ]
      },
      "ERISAPlan": {
        "header": "ERISA Plan Assets (Is the fund a plan asset)?",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ERISAPlan",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No"
        ]
      },
      "ICAExempt": {
        "header": "Investment Company Act exemption, if applicable, 3c1 or 3c7 fund?",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ICAExempt",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "3(c)(1)",
          "3(c)(7)",
          "Not Applicable"
        ]
      },
      "CommodityPool": {
        "header": "Is the entity a commodity pool?",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CommodityPool",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No"
        ]
      },
      "CIKNum": {
        "header": "CIK Number (Central Index Key given by the SEC)",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CIKNum",
        "cellEditor": "agTextCellEditor"
      },
      "SECFormDFile": {
        "header": "SEC Form D Filing",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "SECFormDFile",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No"
        ]
      },
      "SECFormDNum": {
        "header": "Form D Filing Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "SECFormDNum",
        "cellEditor": "agTextCellEditor"
      },
      "SECPrivFundID": {
        "header": "SEC Private Fund ID",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "SECPrivFundID",
        "cellEditor": "agTextCellEditor"
      },
      "ADVStatus": {
        "header": "Form ADV Status",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ADVStatus",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Private Fund",
          "Related Person",
          "Not Applicable"
        ]
      },
      "AddRegCountry": {
        "header": "Additional Registration Country",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AddRegCountry",
        "cellEditor": "agTextCellEditor"
      },
      "AddRegNum": {
        "header": "Additional Registration Number",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AddRegNum",
        "cellEditor": "agTextCellEditor"
      },
      "AddRegDate": {
        "header": "Additional Registration Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AddRegDate",
        "cellEditor": "agTextCellEditor"
      },
      "AltTaxID": {
        "header": "Alternate Tax ID",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AltTaxID",
        "cellEditor": "agTextCellEditor"
      },    
      "FATCAReg": {
        "header": "Was the entity registered under FATCA?",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FATCAReg",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "Yes",
          "No",
          "Not Applicable"
        ]
      },
      "GIIN": {
        "header": "FATCA Registration number (GIIN)",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "GIIN",
        "cellEditor": "agTextCellEditor"
      },
      "8832ElectDate": {
        "header": "8832ElectDate",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "8832ElectDate",
        "cellEditor": "agTextCellEditor"
      },
      "8832ElectClass": {
        "header": "8832 Entity Classification Election",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "8832ElectClass",
        "cellEditor": "agTextCellEditor",
        "element": "dropdown",
        "dropdown": [
          "A domestic eligible entity electing to be classified as an association taxable as a corporation.",
          "A domestic eligible entity electing to be classified as a partnership.",
          "A domestic eligible entity with a single owner electing to be disregarded as a separate entity.",
          "A foreign eligible entity electing to be classified as an association taxable as a corporation.",
          "A foreign eligible entity electing to be classified as a partnership.",
          "A foreign eligible entity with a single owner electing to be disregarded as a separate entity."
        ]
      }
    }
  }
  export  { entitydbRt }
  